import { makeMessages, makeTranslation } from 'utils'

export default makeMessages(
  {
    deadlineOrderDate: 'deadlineOrderDate',
    switchBtn: { id: 'navbar.menu.changeLocation' },
  },
  makeTranslation('dashboard'),
)
